import type { Socket } from 'socket.io-client';
import { writable } from 'svelte/store';

export const socketIOStore = writable<Socket>(null);

// chat
export const onMessageListener = writable<unknown>(null);
export const onReadListener = writable<unknown>(null);
export const onDeleteListener = writable<unknown>(null);
export const onEditListener = writable<unknown>(null);
export const onBlockedListener = writable<unknown>(null);
export const onlineListener = writable<unknown>(null);
export const typingListener = writable<unknown>(null);
